import { Document, Page, PDFViewer, StyleSheet, Text, View } from '@react-pdf/renderer';
import { FC, Fragment, useEffect, useState } from 'react';
import { ExportProps } from '../../components/Export/Export.types';
import { PdfPage } from './PdfViewer.styles';

const PdfDocument: FC<ExportProps> = ({ columnHeaders, rowData }) => {
  const rowCount = columnHeaders.length || 0;

  const styles = StyleSheet.create({
    page: {
      padding: 32,
    },
    section: {
      fontSize: 8,
      flexDirection: 'row',
      borderBottom: '1px solid black',
    },
    header: {
      fontSize: 12,
      padding: 8,
      width: `calc(100% / ${rowCount})`,
    },
    row: {
      padding: 8,
      width: `calc(100% / ${rowCount})`,
    },
    noData: {
      margin: 'auto',
      marginTop: 64,
    },
  });

  return (
    <Document>
      <Page style={styles.page} size='LETTER'>
        <View style={styles.section}>
          {columnHeaders.map((header) =>
            header.field ? (
              <Text style={styles.header} key={header.headerName}>
                {header.headerName}
              </Text>
            ) : (
              <Fragment key={header.headerName} />
            )
          )}
        </View>
        {rowData.map((row) => (
          <View style={styles.section}>
            {columnHeaders.map((header) =>
              header.field ? (
                <Text style={styles.row} key={header.field}>
                  {row[header.field]}
                </Text>
              ) : (
                <Fragment key={header.field} />
              )
            )}
          </View>
        ))}
        {columnHeaders.length === 0 && rowData.length === 0 ? (
          <Text style={styles.noData}>No document has been exported</Text>
        ) : (
          <></>
        )}
      </Page>
    </Document>
  );
};

const PdfViewer: FC = () => {
  const [pdfData, setPdfData] = useState({ columnHeaders: [], rowData: [] });

  useEffect(() => {
    const localStoragePdfData = localStorage.getItem('pdfData');
    if (localStoragePdfData) setPdfData(JSON.parse(localStoragePdfData));
  }, []);

  return (
    <PdfPage data-testid='pdfViewer'>
      <PDFViewer width='100%' height='100%'>
        <PdfDocument columnHeaders={pdfData.columnHeaders} rowData={pdfData.rowData} />
      </PDFViewer>
    </PdfPage>
  );
};

export default PdfViewer;
